import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    PLATFORM_ID,
    Renderer2,
} from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { FormControl } from "@angular/forms";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { Partner } from "@app/models/partner/IPartner";
import { AuthGuardService } from "@app/services/auth-guard.service";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { SearchService } from "@app/services/search.service";
import {
    debounceTime,
    filter,
    startWith,
    Subject,
    takeUntil,
    forkJoin,
} from "rxjs";
import { MEDIA_TOKEN } from "../../../../../../tockens";
import { PeakworkService } from "@app/services/peakwork.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { I18nService } from "@app/services/i18n.service";
@Component({
    selector: "clever-reiseziel",
    templateUrl: "./reiseziel.component.html",
    styleUrls: ["./reiseziel.component.scss"],
    animations: [
        trigger("zoom", [
            state(
                "leftBottom",
                style({
                    transform: "scale(0.3)",
                    transformOrigin: "left bottom",
                    opacity: "0",
                })
            ),
            state("default", style({ transform: "scale(1)", opacity: "1" })),
            transition("* <=> default", animate("10ms cubic-bezier(0.25,1,.25,1)")),
        ]),
    ],
    standalone: false,
})
export class ReisezielComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() type: string;
    @Input() completion: any;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    focus: boolean = true;
    suffix: string = "Pauschalreisen";
    media: string = "lg";
    origin: string = "default";
    zielText: string = "Reiseziel oder Hotelname";

    searchObj: any[];
    mySearchControl = new FormControl();
    partner: Partner;
    ops: string = "";

    defaultdatas = [
        {
            code: "133",
            name: "Mallorca",
            superRegion: "Balearen",
            img: "https://media.acvis.de/searchimages/mallorca.webp",
            type: 3,
        },
        {
            code: "149",
            name: "Türkische Riviera",
            img: "https://media.acvis.de/searchimages/turkisch.webp",
            superRegion: "Türkei",
            type: 3,
        },
        {
            code: "46",
            name: "Kreta",
            img: "https://media.acvis.de/searchimages/kreta.jpeg",
            superRegion: "Griechische Inseln",
            type: 3,
        },
        {
            code: "127",
            name: "Fuerteventura",
            img: "https://media.acvis.de/searchimages/fuerta.webp",
            superRegion: "Kanaren",
            type: 3,
        },
        {
            code: "160",
            name: "Dubai",
            img: "https://media.acvis.de/searchimages/dubai.webp",
            superRegion: "Vereinigte Arabische Emirate",
            type: 3,
        },
        {
            code: "MV",
            name: "Malediven",
            img: "https://media.acvis.de/searchimages/malediven.webp",
            type: 4,
        },
        {
            code: "",
            name: "Egal Wohin!",
            type: -1,
        },
    ];

    defaultdatasBahn = [
        {
            code: "100003",
            name: "Deutschland Nord",
            img: "https://media.acvis.de/topregions/100003.webp",
            type: 3,
        },
        {
            code: "100006",
            name: "Deutschland Süd",
            img: "https://media.acvis.de/topregions/100006.webp",
            type: 3,
        },
        {
            code: "100005",
            name: "Deutschland Ost",
            img: "https://media.acvis.de/topregions/100005.webp",
            type: 3,
        },
        {
            code: "100004",
            name: "Deutschland West",
            img: "https://media.acvis.de/topregions/100004.webp",
            type: 3,
        },
        {
            code: "572",
            name: "Österreich",
            img: "https://media.acvis.de/topregions/572.webp",
            type: 3,
        },
        {
            code: "",
            name: "Egal Wohin!",
            type: -1,
        },
    ];
    destroyRef = inject(DestroyRef);
    recentSearch: any[];

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        protected searchService: SearchService,
        protected hotelService: HotelFiltersService,
        protected guardService: AuthGuardService,
        protected peakworkservie: PeakworkService,
        protected i18service: I18nService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        if (this.type === "hotelonly") {
            this.suffix = "Hotel";
        }
        if (this.type === "railtravel") {
            this.suffix = "Bahnreisen";
        }
        this.initPartner();
        this.initMedia();
        this.initFilterSub();
        this.initSearchChange();
        this.initSearchHistory();
    }

    initPartner(): void {
        this.guardService.getPartner$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((partner) => {
                if (partner?.partnerid?.length > 0) {
                    this.partner = partner;
                    for (let i = 0; i < this.partner?.agenturen?.length; i++) {
                        if (this.partner?.agenturen[i]?.aktiv) {
                            this.ops += this.partner?.agenturen[i]?.code + ",";
                        }
                    }
                }
                this.cdr.detectChanges();
            });
    }

    initSearchHistory() {
        if (this.isBrowser) {
            let cache = localStorage.getItem("pauschalreise");
            this.recentSearch = JSON.parse(cache);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async initFilterSub() {
        this.hotelService.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((filter: ParamFilters) => {
                if (filter?.pauschalreiseResult?.data?.name?.length > 0) {
                    if (this.zielText !== filter.pauschalreiseResult.data.name) {
                        this.zielText = filter.pauschalreiseResult.data.name;
                    }
                } else {
                    this.zielText = "Reiseziel oder Hotelname";
                }
                this.cdr.detectChanges();
            });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = "xs";
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = "sm";
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = "md";
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = "lg";
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = "xl";
        }
        this.cdr.detectChanges();
    }

    detectPast(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        this.mySearchControl.setValue(" ", {
            emitEvent: true,
            emitViewToModelChange: true,
        });
        this.cdr.detectChanges();
        this.mySearchControl.setValue(ev.clipboardData.getData("text"), {
            emitEvent: true,
            emitViewToModelChange: true,
        });
        this.cdr.detectChanges();
    }

    initSearchChange(): void {
        const filterShare = this.mySearchControl.valueChanges
            .pipe(
                startWith(""),
                debounceTime(100),
                filter((value) => typeof value === "string" && value?.length > 0)
            )
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((value) => {
                this.getRes(value);
            });
    }

    async getRes(value) {
        let peakworkobs = null;
        let trafficsobs = null;

        if (
            this.partner.peakwork?.active &&
            this.partner.peakwork?.apikey?.length > 0
        ) {
            const peakfilter = {
                keyWord: {
                    value: value,
                    includes: ["hotel", "region", "country", "city"],
                },
                authKey: this.partner.peakwork?.apikey,
                language: this.i18service.lang,
                resultsPerGroup: 10,
                requestType: this.type === "pauschal" ? "PACKAGE" : "HOTEL",
                authKeyFilter: false,
            };

            peakworkobs = this.peakworkservie.request(
                { filter: peakfilter },
                "completion"
            );
            // console.log(peakfilter)
        }
        if (
            this.partner.traffics?.aktiv &&
            this.partner.traffics?.licence?.length > 0
        ) {
            const myobj = {
                searchValue: value,
                language: this.i18service.lang,
                licence: this.partner.traffics.licence,
                productType: this.type,
                subTypeRegion: true,
                subTypeLocation: true,
                subTypeGiataHotel: true,
                subTypeTrainStation: false,
                subTypeCountry: true,
                tourOperatorList: this.ops,
                limit: 10,
            };
            trafficsobs = this.searchService.searchEntries(myobj, "completions");
        }

        const obs: any = {};
        if (peakworkobs) {
            obs.peakwork = peakworkobs;
        }
        if (trafficsobs) {
            obs.traffics = trafficsobs;
        }
        forkJoin(obs)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res: any) => {
                // console.log(res)
                this.mergDatas(res);
            });
    }

    async mergDatas(res) {
        const alldatas = [];

        for (let i = 0; i < res?.traffics?.length; i++) {
            alldatas.push({
                name: res.traffics[i].name,
                code: res.traffics[i].code,
                location: res.traffics[i]?.location?.name,
                region: res.traffics[i]?.region?.name,
                superRegion: res.traffics[i]?.superRegion?.name,
                traffics: true,
                type: res.traffics[i].type,
            });
        }

        for (let i = 0; i < res?.peakwork?.keyWordGroups?.length; i++) {
            if (res.peakwork?.keyWordGroups[i].name === "region") {
                for (
                    let j = 0;
                    j < res.peakwork?.keyWordGroups[i].keyWords.length;
                    j++
                ) {
                    const index = this.checkinarray(
                        alldatas,
                        res.peakwork?.keyWordGroups[i].keyWords[j]
                    );
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name.split(
                                "<em>"
                            )?.[0],
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            superRegion: res.peakwork?.keyWordGroups[i].keyWords[j].name
                                .split("<em>")?.[1]
                                ?.split("</em>")?.[0],
                            peakwork: true,
                            type: 3,
                        });
                    }
                }
            }
            if (res.peakwork?.keyWordGroups[i].name === "country") {
                for (
                    let j = 0;
                    j < res.peakwork?.keyWordGroups[i].keyWords.length;
                    j++
                ) {
                    const index = this.checkinarray(
                        alldatas,
                        res.peakwork?.keyWordGroups[i].keyWords[j]
                    );
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name,
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            peakwork: true,
                            type: 4,
                        });
                    }
                }
            }
            if (res.peakwork?.keyWordGroups[i].name === "hotel") {
                for (
                    let j = 0;
                    j < res.peakwork?.keyWordGroups[i].keyWords.length;
                    j++
                ) {
                    const index = this.checkinarray(
                        alldatas,
                        res.peakwork?.keyWordGroups[i].keyWords[j]
                    );
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name.split(
                                "<em>"
                            )?.[0],
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            superRegion: res.peakwork?.keyWordGroups[i].keyWords[j].name
                                .split("<em>")?.[1]
                                ?.split("</em>")?.[0],
                            peakwork: true,
                            type: 1,
                        });
                    }
                }
            }
            if (res.peakwork?.keyWordGroups[i].name === "city") {
                for (
                    let j = 0;
                    j < res.peakwork?.keyWordGroups[i].keyWords.length;
                    j++
                ) {
                    const index = this.checkinarray(
                        alldatas,
                        res.peakwork?.keyWordGroups[i].keyWords[j]
                    );
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name.split(
                                "<em>"
                            )?.[0],
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            region: res.peakwork?.keyWordGroups[i].keyWords[j].name
                                .split("<em>")?.[1]
                                ?.split("</em>")?.[0],
                            peakwork: true,
                            type: 2,
                        });
                    }
                }
            }
        }
        if (alldatas?.length > 0) {
            alldatas.sort((a, b) => {
                return b.data?.name
                    ?.toLowerCase()
                    .localeCompare(a.data?.name?.toLowerCase());
            });
            this.searchObj = alldatas;
        }
        this.cdr.detectChanges();
        // console.log(alldatas)
    }

    checkinarray(array, value): any {
        for (let i = 0; i < array.length; i++) {
            if (array[i].code === value.id) {
                return i;
            }
        }

        return -1;
    }

    openModal(ev): void {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin("leftBottom");
    }

    openModalMobile(ev): void {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin("leftBottom");
    }

    closeModal(): void {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile(): void {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    zoomin(position: any): void {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = "default";
            this.cdr.detectChanges();
        });
    }

    clearText(): void {
        this.mySearchControl.setValue("");
        this.focus = false;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.focus = true;
            this.cdr.detectChanges();
        }, 50);
    }

    selectValue(item): void {
        if (item.type === -1) {
            this.zielText = "Reiseziel oder Hotelname";
            this.showModal = false;
            this.mySearchControl.setValue("");
            this.hotelService.pauschalreiseResult(null);
        } else {
            this.zielText = item?.name;
            this.showModal = false;
            this.mySearchControl.setValue("");
            this.hotelService.pauschalreiseResult({
                peakwork: item.peakwork,
                type: item.type,
                data: {
                    name: item.name,
                    code: item.code,
                },
            });
        }
    }

    async setSelection(item) {
        this.showModal = false;
        if (item?.link?.length > 0) {
            const link = document.createElement("a");
            link.href = item.link;
            link.setAttribute("visibility", "hidden");
            link.click();
        } else {
            this.hotelService.onlySetRealParams(item.inputData?.realparams);
            this.hotelService.gotoUrl("");
        }
        this.cdr.detectChanges();
    }

    gotoOffer(item: ParamFilters) {
        this.hotelService.onlySetRealParams(item);
        this.hotelService.gotoUrl("");
    }

    removeHistory(index) {
        this.recentSearch.splice(index, 1);
        this.hotelService.savePauschalreiseToLocal(index);
    }
}
